import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(Router);
const router = new Router({
  base: "/",
  mode: "hash",
  linkActiveClass: "active",
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (!to.meta.public && !localStorage.token) {
    next({
      path: "/login",
      query: {
        redirect: to.fullPath
      }
    });
    return;
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
